import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { register, load, getInstances, isInstance } from '@shopify/theme-sections';
import * as Cart from '@shopify/theme-cart';
import * as a11y from '@shopify/theme-a11y';
import Swiper, { Navigation } from 'swiper';
import * as Layout from '../utilities/layout';
import * as Helpers from '../utilities/helpers';
Swiper.use([Navigation]);
Avatar.theme = Avatar.theme || {};
Avatar.skup = Avatar.skup || {};
Avatar.theme.sections = Avatar.theme.sections || {};

Avatar.theme.sections.SliderCart = function SliderCart() {
  var selectors = {
    sliderCartContainer: '[]',
    themeOverlay: '[data-overlay]',
    sliderCartOpen: '[data-slider-cart-open]',
    sliderCartClose: '[data-slider-cart-close]',
    sliderCart: '[data-slider-cart]',
    sliderCartLoading: '[data-slider-cart-loading]',
    sliderCartCount: '[data-slider-cart-count]',
    sliderCartItems: '[data-slider-cart-items]',
    sliderCartHeader: '[data-slider-cart-header]',
    sliderCartFooter: '[data-slider-cart-footer]',
    sliderCartRecommendations: '[data-slider-cart-recommendations]',
    sliderCartRecommendation: '[data-recommend-product]',
    addToCartForms: '[data-ajax-submit]',
    addToCartError: '[data-ajax-error]',
    addRecProductToCart: '[data-add-rec]',
    qtyStep: '[data-slider-cart-qty]',
    removeItem: '[data-remove-item]',
    lineItem: '[data-item-key]',
    sliderCartPrices: '[data-slider-cart-total-container]',
    productRecommendations: '.product-recommendations',
    cartItemQuantityInput: '.cart-item-quantity-input',
    sliderCartAdditionalButtons: '[data-slider-cart-additional-checkout]'
  };
  var classes = {
    sliderCartTranslate: 'tw-translate-x-full',
    halfOpacity: 'tw-opacity-50',
    hide: 'tw-hidden',
    textRight: 'tw-text-right',
    textCenter: 'tw-text-center',
    noCookies: 'no-cookies'
  };
  var sectionName = 'slider-cart';
  register(sectionName, {
    onLoad: function onLoad() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = _this.container;
                _this.sliderCart = container.querySelector(selectors.sliderCart);
                _this.sliderCartContainer = container;
                _this.sliderCartLoading = container.querySelector(selectors.sliderCartLoading);
                _this.sliderCartHeader = container.querySelector(selectors.sliderCartHeader);
                _this.sliderCartFooter = container.querySelector(selectors.sliderCartFooter);
                _this.sliderCartItems = container.querySelector(selectors.sliderCartItems);
                _this.sliderCartOpen = document.querySelector(selectors.sliderCartOpen);
                _this.sliderCartClose = container.querySelector(selectors.sliderCartClose);
                _this.themeOverlay = document.querySelector(selectors.themeOverlay);
                _this.addToCartForms = document.querySelectorAll(selectors.addToCartForms);
                _this.addRecProductToCart = container.querySelectorAll(selectors.addRecProductToCart);
                _this.removeItems = container.querySelectorAll(selectors.removeItem);
                _this.qtyStep = container.querySelectorAll(selectors.qtyStep);
                _this.sliderCartRecommendationsContainer = container.querySelector(selectors.sliderCartRecommendations);
                _this.sliderCartRecommendation = container.querySelectorAll(selectors.sliderCartRecommendation);
                _this.sliderCartAdditionalButtons = container.querySelector(selectors.sliderCartAdditionalButtons);
                _this.eventHandlers = {};
                _this.mqSmall = window.matchMedia(Avatar.theme.settings.mediaQuery.small);
                _this.mqSmall.onchange = _this.sizeCart.bind(_this);

                if (_this.sliderCartOpen) {
                  _this.eventHandlers.openSliderCart = _this.openSliderCart.bind(_this);

                  _this.sliderCartOpen.addEventListener('click', _this.eventHandlers.openSliderCart);
                }

                if (_this.sliderCartClose) {
                  _this.eventHandlers.closeSliderCart = _this.closeSliderCart.bind(_this);

                  _this.sliderCartClose.addEventListener('click', _this.eventHandlers.closeSliderCart);
                }

                if (_this.addToCartForms) {
                  _this.setAjaxForms(_this.addToCartForms);

                  _this.eventHandlers.addToCart = _this.addToCart.bind(_this);

                  _this.addToCartForms.forEach(function (form) {
                    return form.addEventListener('submit', _this.eventHandlers.addToCart);
                  });

                  _this.eventHandlers.getNewForms = _this.getNewForms.bind(_this);
                  document.addEventListener('product-recommendations', _this.eventHandlers.getNewForms);
                }

                if (_this.removeItems || _this.qtyStep) {
                  _this.initSliderCartListeners();
                }

                if (_this.sliderCart) {
                  _this.sizeCart();

                  _this.eventHandlers.sliderCartKeyupHandler = _this.sliderCartKeyupHandler.bind(_this);
                  _this.eventHandlers.sizeCart = _this.sizeCart.bind(_this);
                  window.addEventListener('resize', _this.eventHandlers.sizeCart);

                  _this.initMutationObservers();

                  _this.checkCookies();
                }

                if (_this.addRecProductToCart) {
                  _this.initRecListeners();

                  _this.sizeCart();
                }

                if (_this.sliderCartRecommendationsContainer) {
                  _this.initSlider();
                }

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // Only needed if included as section instead of static global settings
    // onSelect() {
    //   Avatar.skup.sliderCart = true;
    //   const timer = setInterval(previewSliderCart.bind(this), 250);
    //   function previewSliderCart() {
    //     if (this.sliderCart) {
    //       this.openSliderCart();
    //       clearInterval(timer);
    //     }
    //   }
    // },
    // onDeselect() {
    //   this.closeSliderCart();
    // },
    // onBlockSelect() {
    // },
    openSliderCart: function openSliderCart(evt) {
      var _this2 = this;

      // Only needed if we want to prevent slider cart on '/cart' route.
      // if (window.location.pathname.includes('/cart')) {
      //   evt.preventDefault();
      //   return;
      // }
      evt && evt.preventDefault();
      Layout.fadeInOverlay();
      Layout.scrollLock();
      this.sliderCart.classList.remove(classes.hide);
      this.container.classList.remove(classes.hide);
      setTimeout(function () {
        _this2.sliderCart.classList.remove(classes.sliderCartTranslate);

        _this2.sizeCart();
      }, 0);
      this.eventHandlers.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.container.addEventListener('click', this.eventHandlers.handleOutsideClick);
      this.container.addEventListener('keyup', this.eventHandlers.sliderCartKeyupHandler);
      a11y.trapFocus(this.sliderCartContainer, {
        elementToFocus: this.sliderCart
      });
    },
    closeSliderCart: function closeSliderCart() {
      var _this3 = this;

      Layout.fadeOutOverlay();
      Layout.scrollUnlock();
      this.sliderCart.classList.add(classes.sliderCartTranslate);
      this.sliderCart.addEventListener('transitionend', function () {
        _this3.sliderCart.classList.add(classes.hide);

        _this3.container.classList.add(classes.hide);
      }, {
        once: true
      });
      this.container.removeEventListener('keyup', this.eventHandlers.sliderCartKeyupHandler);
      this.container.removeEventListener('click', this.eventHandlers.handleOutsideClick);
      a11y.removeTrapFocus();
      a11y.forceFocus(document.body);
    },
    handleOutsideClick: function handleOutsideClick(evt) {
      var target = evt.target;

      if (!target.closest(selectors.sliderCart)) {
        this.closeSliderCart();
      }
    },
    sizeCart: function sizeCart() {
      if (!this.sliderCartItems) {
        return;
      }

      var windowHeight = window.innerHeight;
      var headerHeight = this.sliderCartHeader.clientHeight;
      var footerHeight = this.sliderCartFooter.clientHeight;
      var spacingHeight = 22;
      var itemsHeight = windowHeight - headerHeight - footerHeight - spacingHeight;

      if (this.mqSmall.matches && itemsHeight < 300) {
        this.sliderCartItems.style.height = '';
        return;
      }

      this.sliderCartItems.style.height = "".concat(itemsHeight, "px");
    },
    initMutationObservers: function initMutationObservers() {
      var _this4 = this;

      var cartItems = this.sliderCartItems;
      var checkoutButtons = this.sliderCartAdditionalButtons;
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };

      var handleCartItemChange = function handleCartItemChange(mutationsList) {
        // eslint-disable-next-line no-restricted-syntax
        var _iterator = _createForOfIteratorHelper(mutationsList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;

            if (mutation.type === 'childList') {
              _this4.sizeCart();

              return;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      var handleCheckoutButtonChange = function handleCheckoutButtonChange(mutationsList) {
        // eslint-disable-next-line no-restricted-syntax
        var _iterator2 = _createForOfIteratorHelper(mutationsList),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mutation = _step2.value;

            if (mutation.type === 'attributes') {
              _this4.sizeCart();

              return;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };

      var itemObserver = new MutationObserver(handleCartItemChange);
      itemObserver.observe(cartItems, config);

      if (checkoutButtons) {
        var checkoutButtonsObserver = new MutationObserver(handleCheckoutButtonChange);
        checkoutButtonsObserver.observe(checkoutButtons, config);
      }
    },
    sliderCartKeyupHandler: function sliderCartKeyupHandler(evt) {
      if (evt.keyCode === Avatar.theme.keyboardKeys.ESCAPE) {
        this.closeSliderCart();
      }
    },
    setAjaxForms: function setAjaxForms(forms) {
      forms.forEach(function (form) {
        form.setAttribute('data-ajax-submit', true);
      });
    },
    getNewForms: function getNewForms() {
      var _this5 = this;

      var recommendationsContainer = document.querySelector(selectors.productRecommendations);
      var forms = recommendationsContainer.querySelectorAll('[data-ajax-submit]');
      this.setAjaxForms(forms);
      forms.forEach(function (form) {
        return form.addEventListener('submit', _this5.addToCart.bind(_this5));
      });
    },
    addToCart: function addToCart(evt) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var productForm, product;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                productForm = evt.currentTarget;

                if (window.location.pathname.includes('/cart')) {
                  productForm.submit();
                }

                evt.preventDefault();

                _this6.showAndSizeLoader();

                _context3.next = 6;
                return Cart.addItemFromForm(productForm).catch( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(err) {
                    var json;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return err.json();

                          case 2:
                            json = _context2.sent;
                            _context2.next = 5;
                            return _this6.handleCartError(json, productForm);

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 6:
                product = _context3.sent;

                if (product) {
                  if (_this6.sliderCartRecommendationsContainer) {
                    _this6.getRecommendedProducts(product.product_id);
                  }

                  _this6.openSliderCart();

                  _this6.refreshCartSlider();
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleCartError: function handleCartError(error, currentForm) {
      var _this7 = this;

      var ajaxError = currentForm.parentElement.querySelector(selectors.addToCartError);
      var errorMessage = "".concat(error.message, ": ").concat(error.description);
      ajaxError.textContent = errorMessage;
      ajaxError.classList.remove(classes.hide);
      ajaxError.focus();
      setTimeout(function () {
        ajaxError.classList.add(classes.hide);

        _this7.sizeCart();
      }, 6000);
    },
    getRecommendedProducts: function getRecommendedProducts(productId) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var url, res, recJson;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = "/recommendations/products.json?product_id=".concat(productId, "&limit=3");
                _context4.next = 3;
                return fetch(url);

              case 3:
                res = _context4.sent;
                _context4.next = 6;
                return res.json();

              case 6:
                recJson = _context4.sent;

                if (recJson.products.length !== 0) {
                  _this8.renderRecommendations(recJson.products);
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    renderRecommendations: function renderRecommendations(products) {
      var _this9 = this;

      var currentRecs = document.querySelectorAll(selectors.sliderCartRecommendation);
      var originalSlides = Array.from(currentRecs).filter(function (rec) {
        return !rec.classList.contains('swiper-slide-duplicate');
      });
      var swiperDuplicates = Array.from(currentRecs).filter(function (rec) {
        return rec.classList.contains('swiper-slide-duplicate');
      });
      products.forEach(function (product, idx) {
        _this9.replaceRecommendationContent(originalSlides, product, idx);
      });

      for (var i = 0; i < swiperDuplicates.length; i++) {
        var productJson = i === 0 ? products[products.length - 1] : products[0];
        this.replaceRecommendationContent(swiperDuplicates, productJson, i);
      }
    },
    replaceRecommendationContent: function replaceRecommendationContent(elements, content, idx) {
      var recImage = elements[idx].querySelector('[data-rec-image]');
      var recTitle = elements[idx].querySelector('[data-rec-title]');
      var recPrice = elements[idx].querySelector('[data-rec-price]');
      var recProductId = elements[idx].querySelector('[data-rec-product-id]');
      var recProductLink = elements[idx].querySelector('[data-rec-link]');
      var recProductLinkContent = elements[idx].querySelector('[data-rec-link-content]');
      recImage.dataset.src = Shopify.theme.ThemeImages.getSizedImageUrl(content.featured_image, '250x');
      recImage.src = Shopify.theme.ThemeImages.getSizedImageUrl(content.featured_image, '250x');
      recImage.alt = content.media[0].alt || content.title;
      recTitle.textContent = content.title;
      recPrice.textContent = Avatar.theme.Currency.formatMoney(content.price);
      recProductId.setAttribute('data-rec-product-id', content.variants[0].id);
      recProductLink.href = content.url;
      recProductLinkContent.href = content.url;

      if (content.variants[0].available === false) {
        recProductId.textContent = Avatar.theme.i18n.soldOut;
        recProductId.setAttribute('disabled', true);
      }
    },
    addRecProduct: function addRecProduct(evt) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var currentTarget, productId;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                evt.preventDefault();

                _this10.showAndSizeLoader();

                currentTarget = evt.currentTarget;
                productId = parseInt(currentTarget.getAttribute('data-rec-product-id'), 10);
                _context6.next = 6;
                return Cart.addItem(productId).catch( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(err) {
                    var json;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return err.json();

                          case 2:
                            json = _context5.sent;
                            _context5.next = 5;
                            return _this10.handleCartError(json, _this10.sliderCart);

                          case 5:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 6:
                _this10.refreshCartSlider();

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    handleQtyClick: function handleQtyClick(evt) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var target, qtyInput, currentVal, newVal;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                evt.preventDefault();

                _this11.showAndSizeLoader();

                target = evt.currentTarget;
                qtyInput = target.previousElementSibling || target.nextElementSibling;
                currentVal = parseInt(qtyInput.value, 10);
                target.style.pointerEvents = 'none';
                target.disabled = 'true';
                target.style.opacity = '0.5';

                if ('stepUp' in target.dataset) {
                  newVal = currentVal + 1;

                  _this11.changeItem(target, newVal);
                } else if ('stepDown' in target.dataset) {
                  newVal = currentVal - 1;

                  _this11.changeItem(target, newVal);
                }

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    handleQtyChange: function handleQtyChange(evt) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var qtyInput, stepUpButton;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                evt.preventDefault();

                _this12.showAndSizeLoader();

                qtyInput = evt.currentTarget;
                stepUpButton = qtyInput.nextElementSibling;

                _this12.changeItem(stepUpButton, parseInt(qtyInput.value, 10));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    changeItem: function changeItem(target, quantity) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var lineItem, key;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                lineItem = target.closest(selectors.lineItem);
                key = lineItem.getAttribute('data-item-key');
                _context9.next = 4;
                return Cart.updateItem(key, {
                  quantity: quantity
                });

              case 4:
                _this13.refreshCartSlider();

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    removeCartItem: function removeCartItem(evt) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var lineItem, key;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                evt.preventDefault();

                _this14.showAndSizeLoader();

                lineItem = evt.target.closest(selectors.lineItem);
                key = lineItem.getAttribute('data-item-key');
                lineItem.classList.add(classes.halfOpacity);
                _context10.next = 7;
                return Cart.removeItem(key);

              case 7:
                lineItem.remove();

                _this14.refreshCartSlider();

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    refreshCartSlider: function refreshCartSlider() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var cart, sliderCartLoading, sliderCartPrices, url, page, html, domParser, doc, sliderCartLoadingShadow, sliderCartShadow, sliderCart, sliderCartPricesShadow, sliderCartTotalContainer, sliderCartCountShadow, sliderCartCount;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return Cart.getState();

              case 2:
                cart = _context11.sent;

                _this15.updateCartData(cart);

                sliderCartLoading = document.querySelector(selectors.sliderCartLoading);
                sliderCartPrices = document.querySelector(selectors.sliderCartPrices);

                _this15.showAndSizeLoader();

                url = '/cart?view=ajax';
                _context11.next = 10;
                return fetch(url);

              case 10:
                page = _context11.sent;
                _context11.next = 13;
                return page.text();

              case 13:
                html = _context11.sent;
                domParser = new DOMParser();
                doc = domParser.parseFromString(html, 'text/html');
                sliderCartLoadingShadow = doc.querySelector(selectors.sliderCartLoading);

                _this15.showAndSizeLoader(doc);

                sliderCartShadow = doc.querySelector(selectors.sliderCartItems);
                sliderCart = document.querySelector(selectors.sliderCartItems);
                sliderCart.innerHTML = sliderCartShadow.innerHTML;
                sliderCartPricesShadow = doc.querySelector(selectors.sliderCartPrices);
                sliderCartPrices.innerHTML = sliderCartPricesShadow.innerHTML;
                sliderCartTotalContainer = document.querySelector(selectors.sliderCartPrices);

                if (cart.cart_level_discount_applications.length > 0) {
                  sliderCartTotalContainer.classList.add(classes.textRight);
                  sliderCartTotalContainer.classList.remove(classes.textCenter);
                } else {
                  sliderCartTotalContainer.classList.add(classes.textCenter);
                  sliderCartTotalContainer.classList.remove(classes.textRight);
                }

                sliderCartCountShadow = doc.querySelector(selectors.sliderCartCount);
                sliderCartCount = document.querySelector(selectors.sliderCartCount);
                sliderCartCount.textContent = sliderCartCountShadow.textContent;
                sliderCartLoading = document.querySelector(selectors.sliderCartLoading);
                sliderCartLoading.classList.add(classes.hide);

                _this15.initSliderCartListeners();

              case 31:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    showAndSizeLoader: function showAndSizeLoader() {
      var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      var loader = doc.querySelector(selectors.sliderCartLoading);
      var cartItems = doc.querySelector(selectors.sliderCartItems);
      loader.classList.remove(classes.hide);
      loader.style.height = "".concat(cartItems.scrollHeight, "px");
    },
    updateCartData: function updateCartData(cart) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var item_count, items_subtotal_price, headerCartCount, sliderCartCountContainer, sliderCartCount, sliderCartCountText, sliderCartTotalContainer, sliderCartCheckoutButton, sliderCartContinueButton, sliderCartAdditionalButtons, sliderCartShippingTax, _Avatar$theme$i18n$ca, item, items;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                item_count = cart.item_count, items_subtotal_price = cart.items_subtotal_price;
                headerCartCount = document.querySelector('.cart-count');
                sliderCartCountContainer = document.querySelector('[data-slider-cart-count-container]');
                sliderCartCount = document.querySelector('[data-slider-cart-count]');
                sliderCartCountText = document.querySelector('[data-slider-cart-count-text]');
                sliderCartTotalContainer = document.querySelector(selectors.sliderCartPrices);
                sliderCartCheckoutButton = document.querySelector('[data-slider-cart-checkout]');
                sliderCartContinueButton = document.querySelector('[data-slider-cart-continue-shopping]');
                sliderCartAdditionalButtons = document.querySelector('[data-slider-cart-additional-checkout]');
                sliderCartShippingTax = document.querySelector('[data-slider-cart-shipping-tax]');

                if (item_count > 0) {
                  headerCartCount.classList.remove(classes.hide);
                  sliderCartCountContainer.classList.remove(classes.hide);
                  headerCartCount.textContent = item_count;
                  sliderCartCount.textContent = item_count;
                  _Avatar$theme$i18n$ca = Avatar.theme.i18n.cart, item = _Avatar$theme$i18n$ca.item, items = _Avatar$theme$i18n$ca.items;
                  sliderCartCountText.textContent = item_count > 1 ? items : item;
                  sliderCartTotalContainer.classList.remove(classes.hide);
                  sliderCartCheckoutButton.classList.remove(classes.hide);
                  sliderCartContinueButton.classList.add(classes.hide);
                  sliderCartShippingTax.classList.remove(classes.hide);

                  if (sliderCartAdditionalButtons) {
                    sliderCartAdditionalButtons.classList.remove(classes.hide);
                  }
                } else {
                  headerCartCount.classList.add(classes.hide);
                  sliderCartCountContainer.classList.add(classes.hide);
                  sliderCartTotalContainer.classList.add(classes.hide);
                  sliderCartCheckoutButton.classList.add(classes.hide);
                  sliderCartShippingTax.classList.add(classes.hide);
                  sliderCartContinueButton.classList.remove(classes.hide);

                  if (sliderCartAdditionalButtons) {
                    sliderCartAdditionalButtons.classList.add(classes.hide);
                  }
                }

                _this16.sizeCart();

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    initSliderCartListeners: function initSliderCartListeners() {
      var _this17 = this;

      var sliderCart = document.querySelector(selectors.sliderCart);

      if (!sliderCart) {
        return;
      }

      var removeItems = sliderCart.querySelectorAll(selectors.removeItem);
      var qtySteps = sliderCart.querySelectorAll(selectors.qtyStep);
      var qtyInputs = sliderCart.querySelectorAll(selectors.cartItemQuantityInput);
      removeItems.forEach(function (item) {
        return item.addEventListener('click', _this17.removeCartItem.bind(_this17));
      });
      qtySteps.forEach(function (step) {
        return step.addEventListener('click', _this17.handleQtyClick.bind(_this17));
      });
      qtyInputs.forEach(function (step) {
        return step.addEventListener('change', _this17.handleQtyChange.bind(_this17));
      });
    },
    initRecListeners: function initRecListeners() {
      var _this18 = this;

      document.querySelectorAll(selectors.addRecProductToCart).forEach(function (button) {
        return button.addEventListener('click', _this18.addRecProduct.bind(_this18));
      });
    },
    initSlider: function initSlider() {
      this.recSlider = new Swiper(this.sliderCartRecommendationsContainer, {
        observer: true,
        observeParents: true,
        spaceBetween: 32,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
      this.initRecListeners();
    },
    removeSliderCartListeners: function removeSliderCartListeners() {
      var _this19 = this;

      var sliderCart = document.querySelector(selectors.sliderCart);

      if (!sliderCart) {
        return;
      }

      var removeItems = sliderCart.querySelectorAll(selectors.removeItem);
      var qtySteps = sliderCart.querySelectorAll(selectors.qtyStep);
      var qtyInputs = sliderCart.querySelectorAll(selectors.cartItemQuantityInput);
      removeItems.forEach(function (item) {
        return item.removeEventListener('click', _this19.removeCartItem.bind(_this19));
      });
      qtySteps.forEach(function (step) {
        return step.removeEventListener('click', _this19.handleQtyClick.bind(_this19));
      });
      qtyInputs.forEach(function (step) {
        return step.removeEventListener('change', _this19.handleQtyChange.bind(_this19));
      });
    },
    removeRecListeners: function removeRecListeners() {
      var _this20 = this;

      document.querySelectorAll(selectors.addRecProductToCart).forEach(function (button) {
        return button.removeEventListener('click', _this20.addRecProduct.bind(_this20));
      });
    },
    checkCookies: function checkCookies() {
      if (Helpers.cookiesEnabled()) return;
      this.container.classList.add(classes.noCookies);
    },
    onUnload: function onUnload() {
      var _this21 = this;

      Layout.fadeOutOverlay();
      Layout.scrollUnlock();
      this.sliderCartOpen.removeEventListener('click', this.eventHandlers.openSliderCart);
      this.sliderCartClose.removeEventListener('click', this.eventHandlers.closeSliderCart);
      this.addToCartForms.forEach(function (form) {
        return form.removeEventListener('submit', _this21.eventHandlers.addToCart);
      });
      document.removeEventListener('product-recommendations', this.eventHandlers.getNewForms);
      window.removeEventListener('resize', this.eventHandlers.sizeCart);
      this.recSlider.destroy();
      this.removeSliderCartListeners();
      this.removeRecListeners();
    }
  });
  load(sectionName);
  var exists = isInstance(sectionName);

  if (exists) {
    var instance = getInstances(sectionName);
    return {
      instance: instance[0],
      addToCartEvent: instance[0].eventHandlers.addToCart
    };
  }
}();